import React, { useState } from 'react';

const Header = ({ theme, onThemeToggle }) => {
  const [isActive, setIsActive] = useState(false);

  const toggleMenu = () => {
    setIsActive(!isActive);
  };

  return (
    <header className="header">
      <a href="#home" className="logo">ItzMePortfolio</a>
      <nav className={`navbar ${isActive ? 'active' : ''}`}>
        <a href="#home" className="active">Home</a>
        <a href="#about">About</a>
        <a href="#achievement">Certifications</a>
        <a href="#Skills">Skills</a>
        <a href="#Portfolio">Projects</a>
        <a href="#Contact"> Contact</a>
      </nav>
      <div className="header-actions">
        <button
          type="button"
          className="theme-toggle"
          onClick={onThemeToggle}
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          <i className={`fa-solid ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`}></i>
        </button>
        <i
          className={`fa-solid ${isActive ? 'fa-x' : 'fa-bars'}`}
          id="menu-icon"
          onClick={toggleMenu}
        ></i>
      </div>
    </header>
  );
};

export default Header;
